var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWaterTreatmentWorks = function SvgWaterTreatmentWorks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 15h6V9H9zM17 15h6V9h-6zM9 23h6v-6H9zM17 23h6v-6h-6z"
  })));
};
export { SvgWaterTreatmentWorks as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='6' height='6' transform='matrix(1 0 0 -1 9 15)' fill='%234A6067'/%3e %3crect width='6' height='6' transform='matrix(1 0 0 -1 17 15)' fill='%234A6067'/%3e %3crect width='6' height='6' transform='matrix(1 0 0 -1 9 23)' fill='%234A6067'/%3e %3crect width='6' height='6' transform='matrix(1 0 0 -1 17 23)' fill='%234A6067'/%3e %3c/svg%3e";